import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Classifier, CommandResult } from '@amdb/drone/shared/models';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ClassifiersService {
    constructor(private http: HttpClient) {}

    getClassifierList(parentId: number): Promise<Classifier[]> {
        return this.http.get<Classifier[]>(`/api/v1/classifiers/list/${parentId}`).toPromise();
    }

    getAuthorityRoles(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/authority-roles').toPromise();
    }

    getUasZoneVersionReasons(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/uas-zone-version-reasons').toPromise();
    }

    getZoneVariants(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/zone-variants').toPromise();
    }

    getRegions(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/regions').toPromise();
    }

    getUomDimensions(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/uom-dimensions').toPromise();
    }

    getWeekDays(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/weekdays').toPromise();
    }

    getSunriseSunsetEvents(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/sr-ss').toPromise();
    }

    getAuthorityPurposes(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/authority-purposes').toPromise();
    }

    getAirspaceVolumeLimitVerticalReferences(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/airspace-volume-limit-vertical-references').toPromise();
    }

    getAirspaceVolumeCoordinateSystems(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/airspace-volume-coordinate-systems').toPromise();
    }

    getYesNo(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/yes-no').toPromise();
    }

    getUasZoneVersionTypes(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/uas-zone-version-types').toPromise();
    }

    getDataGroups(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>(`/api/v1/classifiers/data-groups`).toPromise();
    }

    getLangClassifiers(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>(`/api/v1/classifiers/lang`).toPromise();
    }

    addClassifier(classifier: Classifier): Promise<CommandResult<void>> {
        return lastValueFrom(this.http.post<CommandResult<void>>('/api/v1/classifiers', classifier));
    }

    editClassifier(classifier: Classifier): Promise<CommandResult<void>> {
        return lastValueFrom(this.http.patch<CommandResult<void>>('/api/v1/classifiers', classifier));
    }

    deleteClassifier(id: number): Promise<CommandResult<void>> {
        return lastValueFrom(this.http.delete<CommandResult<void>>(`/api/v1/classifiers/${id}`));
    }

    getElements(): Promise<Classifier[]> {
        return this.http.get<Classifier[]>('/api/v1/classifiers/elements').toPromise();
    }
}
